var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-form flex-grow-1 d-flex flex-column"},[_c('NotificationForm',{attrs:{"notification":_vm.notification},on:{"submit":function($event){return _vm.onSubmit($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }